import { state } from './signin.state.js';
import { getters } from './signin.getters.js';
import { actions } from './signin.actions.js';
import { mutations } from './signin.mutations.js';

export default {
  state,
  getters,
  actions,
  mutations
};
